import classNames from 'classnames';
import { ErrorMessage, useFormikContext } from 'formik';
import React, { useState } from 'react';
import FieldHook from '../FormFields/FieldHook/FieldHook';

interface StampDutyFormFieldTextInputProps {
  prefix_value?: string;
  validation_rule: string | null;
  max_value: number | null;
  min_value: number | null;
  character_limit: number | null;
  character_min: number | null;
  error_message?: string;
  name: string;
  fieldValue: string | number;
  setFieldValue: (value: string | number) => void;
}

const StampDutyFormFieldTextInput: React.FC<
  StampDutyFormFieldTextInputProps
> = ({
  error_message = undefined,
  name,
  prefix_value = undefined,
  validation_rule = null,
  max_value,
  min_value,
  character_limit,
  character_min,
  fieldValue,
  setFieldValue,
}) => {
  const { errors, touched } = useFormikContext<any>();

  return (
    <>
      <div
        className={classNames(
          'h-14 flex items-center justify-start bg-system/white border border-border/default rounded-default overflow-clip',
          {
            'pl-4': prefix_value,
            'border-border/error': errors[name] && touched[name],
            'border-border/success': !errors[name] && touched[name],
          }
        )}
      >
        {prefix_value && (
          <span className="h-full flex items-center justify-center text-text/body-tint w-[24px]">
            {prefix_value}
          </span>
        )}
        <FieldHook
          type={'text'}
          name={name}
          className="flex-1 border-none h-full appearance-none blur:bg-system/White autofill:shadow-[inset_0_0_0px_1000px_#ffffff] focus:!ring-0 focus:!outline-none"
          autoComplete="off"
          placeholder="250,000"
          value={fieldValue}
          setValue={setFieldValue}
        />
      </div>
      <ErrorMessage
        name={name}
        render={(msg) => (
          <div className="text-text/body-primary pt-2">{msg}</div>
        )}
      />
    </>
  );
};

export default StampDutyFormFieldTextInput;
